import {
  dashboardColor,
  globeColor,
  archiveColor,
  adminColor,
  teamMembersColor,
  managerColor,
  postmasterColor,
  delegateColor,
  importsColor,
  migrationsColor,
  etliveColor,
  registerColor,
  reportColor,
  users,
  suppressionList,
  emailDelivery,
} from "Icons/index";

export default (isDelivery = false) => {
  if (isDelivery) {
    return [
      { category: "", links: [{ path: "/delivery", label: "sidebar.item.emailDelivery", icon: emailDelivery }] },
      {
        category: "sidebar.category.management",
        links: [
          { path: "/delivery/accounts", label: "sidebar.item.emailDelivery.accounts", icon: users },
          { path: "/delivery/domains", label: "sidebar.item.domains", icon: globeColor },
          {
            path: "/delivery/suppression-list",
            label: "sidebar.item.emailDelivery.suppressionList",
            icon: suppressionList,
          },
        ],
      },

      {
        category: "sidebar.category.analysis",

        links: [{ path: "/delivery/tracemail", label: "sidebar.item.etlive", icon: etliveColor }],
      },
    ];
  }

  return [
    { category: "", links: [{ path: "/home", label: "sidebar.item.dashboard", icon: dashboardColor }] },
    {
      category: "sidebar.category.management",
      links: [
        { path: "/domains", label: "sidebar.item.domains", icon: globeColor },
        { path: "/archive", label: "sidebar.item.archive", icon: archiveColor },
      ],
    },
    {
      category: "sidebar.category.roles",
      links: [
        { path: "/admins", label: "sidebar.item.admins", icon: adminColor },
        { path: "/customers", label: "sidebar.item.customers", icon: globeColor },
        { path: "/team_members", label: "sidebar.item.teamMembers", icon: teamMembersColor },
        { path: "/managers", label: "sidebar.item.managers", icon: managerColor },
        { path: "/postmasters", label: "sidebar.item.postmasters", icon: postmasterColor },
        { path: "/delegates", label: "sidebar.item.delegates", icon: delegateColor },
      ],
    },
    {
      category: "sidebar.category.importsMigrations",
      links: [
        { path: "/imports", label: "sidebar.item.imports", icon: importsColor },
        { path: "/migrations", label: "sidebar.item.migrations", icon: migrationsColor },
        { path: "/migrations/status", label: "sidebar.item.migrationStatus", icon: globeColor },
      ],
    },
    {
      category: "sidebar.category.analysis",
      links: [
        { path: "/tracemail", label: "sidebar.item.etlive", icon: etliveColor },
        { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
        { path: "/reports", label: "sidebar.item.reports", icon: reportColor },
        // { path: "/mx", label: "sidebar.item.mx", icon: reportColor },
      ],
    },
  ];
};
